export default __webpack_public_path__ + "static/media/HBIB-logo.9c8071e0.svg";